import React, { useState,useEffect } from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import '../User/profilepage/Profilesettings.css';
import bell from '../../assets/notification.png';
import gal from '../../assets/gallery.png';
import axiosVendorInstance from '../../axiosVendorInstance';
import { toast } from 'react-toastify';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import { Skeleton } from '@mui/material'; 
import DefaultBannerImge from '../../assets/vendortopbackground.png';
import MobileBackIcon from '../../assets/svg/MobileBackIcon';
import VendorTopMenuBar from './VendorLayouts/VendorTopMenuBar';
import VendorSideMenuBar from './VendorLayouts/VendorSideMenuBar';
import Loader from '../../Components/Loader/Loader';

export default function VendorProfile() {
    const [isSubmit, setIsSubmit] = useState(false); 
    const [restaurantImage, setRestaurantImage] = useState(null); 
    const [restaurantImagePreview, setRestaurantImagePreview] = useState(); 
    const [bannerImage, setBannerImage] = useState(null);
    const [bannerImagePreview, setBannerImagePreview] = useState(); 
    const [businessName, setBusinessName] = useState('');
    const [legalBusinessName, setLegalBusinessName] = useState('');
    const [address, setAddress] = useState('');
    const [city, setCity] = useState('');
    const [state, setState] = useState('');
    const [country, setCountry] = useState('');
    const [zipcode, setZipcode] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('');
    const [representativeName, setRepresentativeName] = useState('');
    const [DOB, setDOB] = useState('');
    const [email, setEmail] = useState('');
    const [taxID, setTaxID] = useState('');
    const [routingNumber, setRoutingNumber] = useState('');
    const [accountNumber, setAccountNumber] = useState('');
    const [businessNameError, setBusinessNameError] = useState('');
    const [legalBusinessNameError, setLegalBusinessNameError] = useState('');
    const [addressError, setAddressError] = useState('');
    const [cityError, setCityError] = useState('');
    const [stateError, setStateError] = useState('');
    const [countryError, setCountryError] = useState('');
    const [zipcodeError, setZipcodeError] = useState('');
    const [phoneNumberError, setPhoneNumberError] = useState('');
    const [representativeNameError, setRepresentativeNameError] = useState('');
    const [DOBError, setDOBError] = useState('');
    const [emailError, setEmailError] = useState('');
    const [taxIDError, setTaxIDError] = useState('');
    const [routingNumberError, setRoutingNumberError] = useState('');
    const [accountNumberError, setAccountNumberError] = useState('');
    const [isLoading, setIsLoading] = useState(true);
    const [featureImage, setFeatureImage] = useState(null);
    const [featureImagePreview, setFeatureImagePreview] = useState('');
    const [featureImageError, setFeatureImageError] = useState('');
    const [disableButton, setDisableButton] = useState(true);
    const [initialValues, setInitialValues] = useState({});
  
    useEffect(() => {
        setTimeout(() => {
            setIsLoading(false);
        }, 2000);
    }, []);

    useEffect(() => {
        axiosVendorInstance
            .get('/vendors/account')
            .then((response) => {
                const data = response?.data?.getVendorInfo[0];
                const formattedDate = data?.Date_of_birth 
                    ? data?.Date_of_birth.split(' ')[0]
                    : '';
                
                // Set initial form values
                const initialData = {
                    businessName: data?.Name || '',
                    legalBusinessName: data?.Legal_Business_Name || '',
                    address: data?.Address || '',
                    city: data?.city || '',
                    state: data?.state || '',
                    country: data?.country || '',
                    zipcode: data?.pincode || '',
                    phoneNumber: data?.Phone_number || '',
                    representativeName: data?.Representative_Name || '',
                    DOB: formattedDate,
                    email: data?.Email || '',
                    taxID: data?.EIN_or_Tax_ID || '',
                    routingNumber: data?.Routing_Number || '',
                    accountNumber: data?.Account_Number || '',
                    restaurantImagePreview: data?.Avatar_key || '',
                    bannerImagePreview: data?.Banner_Image || '',
                    featureImagePreview: data?.featureImage || '',
                };

                setBusinessName(initialData?.businessName);
                setLegalBusinessName(initialData?.legalBusinessName);
                setAddress(initialData?.address);
                setCity(initialData?.city);
                setState(initialData?.state);
                setCountry(initialData?.country);
                setZipcode(initialData?.zipcode);
                setPhoneNumber(initialData?.phoneNumber);
                setRepresentativeName(initialData?.representativeName);
                setDOB(initialData?.DOB);
                setEmail(initialData?.email);
                setTaxID(initialData?.taxID);
                setRoutingNumber(initialData?.routingNumber);
                setAccountNumber(initialData?.accountNumber);
                setRestaurantImagePreview(initialData?.restaurantImagePreview);
                setBannerImagePreview(initialData?.bannerImagePreview);
                setFeatureImagePreview(initialData?.featureImagePreview);
                setInitialValues(initialData); // Store initial values
            })
            .catch((error) => console.error('Error fetching user data:', error));
    }, []);

    useEffect(() => {
        const isChanged =
            businessName !== initialValues?.businessName ||
            legalBusinessName !== initialValues?.legalBusinessName ||
            address !== initialValues?.address ||
            city !== initialValues?.city ||
            state !== initialValues?.state ||
            country !== initialValues?.country ||
            zipcode !== initialValues?.zipcode ||
            phoneNumber !== initialValues?.phoneNumber ||
            representativeName !== initialValues?.representativeName ||
            DOB !== initialValues?.DOB ||
            email !== initialValues?.email ||
            taxID !== initialValues?.taxID ||
            routingNumber !== initialValues?.routingNumber ||
            accountNumber !== initialValues?.accountNumber ||
            restaurantImage !== null ||
            bannerImage !== null ||
            featureImage !== null;

        const hasErrors =
            businessNameError ||
            legalBusinessNameError ||
            addressError ||
            cityError ||
            stateError ||
            countryError ||
            zipcodeError ||
            phoneNumberError ||
            representativeNameError ||
            DOBError ||
            emailError ||
            taxIDError ||
            routingNumberError ||
            accountNumberError ||
            featureImageError;

        // Disable button if there are errors or no changes
        setDisableButton(hasErrors || !isChanged);
    }, [
        businessName,
        legalBusinessName,
        address,
        city,
        state,
        country,
        zipcode,
        phoneNumber,
        representativeName,
        DOB,
        email,
        taxID,
        routingNumber,
        accountNumber,
        restaurantImage,
        bannerImage,
        featureImage,
        businessNameError,
        legalBusinessNameError,
        addressError,
        cityError,
        stateError,
        countryError,
        zipcodeError,
        phoneNumberError,
        representativeNameError,
        DOBError,
        emailError,
        taxIDError,
        routingNumberError,
        accountNumberError,
        featureImageError,
        initialValues,
    ]);

    const handleRestaurantImageClick = (e) => {
        const file = e.target.files[0]; 
        if (file) {
            const fileExtension = file.name.split('.').pop().toLowerCase();
            const validImageTypes = ['jpg', 'jpeg', 'png'];
    
            if (!validImageTypes.includes(fileExtension)) {
                alert('Please upload a JPG, JPEG, or PNG file.');
                setRestaurantImagePreview(null);
                return;
            }
    
            const MAX_SIZE = 10 * 1024 * 1024;
            if (file.size > MAX_SIZE) {
                alert('File size must be less than 10MB.');
                setRestaurantImagePreview(null);
                return;
            }
    
            setRestaurantImage(file);
    
            const reader = new FileReader();
            reader.onload = () => {
                setRestaurantImagePreview(reader.result);
            };
            reader.readAsDataURL(file);
        }
    };
    
    const handleBannerClick = (e) => {
        const file = e.target.files[0];
        if (file) {
            const fileExtension = file.name.split('.').pop().toLowerCase();
            const validImageTypes = ['jpg', 'jpeg', 'png'];
    
            if (!validImageTypes.includes(fileExtension)) {
                alert('Please upload a JPG, JPEG, or PNG file.');
                setBannerImagePreview(null);
                return;
            }
    
            const MAX_SIZE = 10 * 1024 * 1024;
            if (file.size > MAX_SIZE) {
                alert('File size must be less than 10MB.');
                setBannerImagePreview(null);
                return;
            }
    
            setBannerImage(file);
    
            const reader = new FileReader();
            reader.onload = () => {
                setBannerImagePreview(reader.result);
            };
            reader.readAsDataURL(file);
        }
    };

    const handleFeatureImageChange = (e) => {
        if (e.target.files.length > 1) {
            setFeatureImageError('You can only upload one image.');
            setFeatureImage(null);
            setFeatureImagePreview(null);
            return;
        }
    
        const file = e.target.files[0];
    
        if (file) {
            const fileExtension = file.name.split('.').pop().toLowerCase();
            const validImageTypes = ['jpg', 'jpeg', 'png'];
    
            if (!validImageTypes.includes(fileExtension)) {
                setFeatureImageError('Please upload a JPG, JPEG, or PNG file.');
                setFeatureImage(null);
                setFeatureImagePreview(null);
                return;
            }
    
            const img = new Image();
            img.src = URL.createObjectURL(file);
            img.onload = () => {
                const width = img.width;
                const height = img.height;
                const aspectRatio = width / height;
    
                if (aspectRatio !== 6 / 4) {
                    setFeatureImageError('Image must be in 6:4 ratio (e.g., 1200x800).');
                    setFeatureImage(null);
                    setFeatureImagePreview(null);
                } else {
                    setFeatureImageError('');
                    setFeatureImage(file);
    
                    const reader = new FileReader();
                    reader.onload = () => {
                        setFeatureImagePreview(reader.result);
                    };
                    reader.readAsDataURL(file);
                }
            };
        }
    };
    
    const handleBusinessNameChange = (e) => {
        const value = e.target.value;

        if (!/^[a-zA-Z0-9\s]{3,}$/.test(value)) {
            setBusinessNameError('Enter valid business name');
        } else {
            setBusinessNameError('');
        }
        setBusinessName(value);
    };

    const handleLegalBusinessNameChange = (e) => {
        const value = e.target.value;
        if (!/^[a-zA-Z0-9\s]{3,}$/.test(value)) {
            setLegalBusinessNameError('Enter valid legal business name');
        } else {
            setLegalBusinessNameError('');
        }
       
        setLegalBusinessName(value);
    };


    const handleAddressChange = (e) => {
        const value = e.target.value;

        if (!/^[a-zA-Z0-9\s,:-]{10,}$/.test(value)) {
            setAddressError('Enter valid Address');
        } else {
            setAddressError('');
        }
      
       
        setAddress(value);
    };

    const handleCityChange = (e) => {
        const value = e.target.value;

        if (!/^[a-zA-Z\s]{3,}$/.test(value)) {
            setCityError('Enter valid city');
            
        } else {
            setCityError('');
        }
        
        setCity(value);
    };


    const handleStateChange = (e) => {
        const value = e.target.value;

        if (!/^[a-zA-Z\s]{2,}$/.test(value)) {
            setStateError('Enter valid state');
            
        } else {
            setStateError('');
        }
       
        setState(value);
    };

    const handleCountryChange = (e) => {
        const value = e.target.value;

        if (!/^[a-zA-Z\s]{2,}$/.test(value)) {
            setCountryError('Enter valid country');
            
        } else {
            setCountryError('');
        }
       
        setCountry(value);
    };

    const handleZipcodeChange = (e) => {
        const value = e.target.value;

        if (!/^[0-9]{5}$/.test(value)) {
            setZipcodeError('Enter valid zipcode');
            
        } else {
            setZipcodeError('');
        }
       
        setZipcode(value);
    };

    const handlePhoneNumberChange = (e) => {
        const value = e.target.value;

        if (!/^\d{10}$/.test(value)) {
            setPhoneNumberError('Enter valid phone number');
            
        } else {
            setPhoneNumberError('');
        }
       
        setPhoneNumber(value);
    };

    const handleRepresentativeNameChange = (e) => {
        const value = e.target.value;

        if (!/^[a-zA-Z\s]{3,}$/.test(value)) {
            setRepresentativeNameError (' Enter Valid Representative name ');
        } else {
            setRepresentativeNameError('');
        }
       
        setRepresentativeName(value);
    };

    const validateAge = (dob) => {
        const birthDate = new Date(dob);
        const today = new Date();
        
        // Calculate age
        let age = today.getFullYear() - birthDate.getFullYear();
        const monthDiff = today.getMonth() - birthDate.getMonth();
        const dayDiff = today.getDate() - birthDate.getDate();
    
        // Adjust age if birthday hasn't occurred this year yet
        if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
            age--;
        }
    
        return age >= 18; // Must be at least 18 years old

    };

    const handleDOBChange = (value) => {
        if (!value) {
        
            const defaultDate = dayjs('01-01-2000', 'YYYY-MM-DD').format('YYYY-MM-DD');
            setDOB(defaultDate);
        } else {
            
            if(validateAge(value)) {
                const formattedDate = dayjs(value).format('YYYY-MM-DD');
                setDOB(formattedDate);
                setDOBError('');
                
            } else  {
                setDOBError('Invalid date format');
                const defaultDate = dayjs('01-01-2000', 'YYYY-MM-DD').format('YYYY-MM-DD');
                setDOB(defaultDate);
            }
        }
    };

    const handleEmailChange = (e) => {
        const value = e.target.value;

        if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value)) {
            setEmailError('Enter Valid email');
        } else {
            setEmailError('');
        }
       
        setEmail(value);
    };


    const handleTaxIDChange = (e) => {
        let value = e.target.value;

        // Remove all non-digit characters (except hyphen if already exists)
        value = value.replace(/\D/g, '');
    
        // Insert hyphen after the first two digits if the value is long enough
        if (value.length > 2) {
            value = value.substring(0, 2) + '-' + value.substring(2, 9); // Ensure the 7 digits after hyphen
        }
     
        // Set value and validate if the format is correct (XX-XXXXXXX)
        if (!/^\d{2}-\d{7}$/.test(value)) {
            setTaxIDError('Please use the format: XX-XXXXXXX.');
        } else {
            setTaxIDError('');
        }
       
        setTaxID(value);
    };


    const validateRoutingNumber = (routingNumber) => {
        if (!/^\d{9}$/.test(routingNumber)) return false; // Must be exactly 9 digits
        
        const digits = routingNumber.split('').map(Number);
        const checksum = (3 * (digits[0] + digits[3] + digits[6])) +
                         (7 * (digits[1] + digits[4] + digits[7])) +
                         (1 * (digits[2] + digits[5] + digits[8]));
        return checksum % 10 === 0; // Valid if divisible by 10
    };

    const handleRoutingNumberChange = (e) => {
        let value = e.target.value;

        // Remove all non-digit characters
        value = value.replace(/\D/g, '');
    
        // Check validity of routing number
        if (value.length === 9 && validateRoutingNumber(value)) {
           
            setRoutingNumberError('invalid routing number');
        } else {
 
            setRoutingNumberError('');
             
            if (value.length === 9 && !validateRoutingNumber(value)) {
                setRoutingNumberError('invalid routing number');
            } else {
                setRoutingNumberError('');
            }
        }
        
        setRoutingNumber(value);
    };

    const handleAccountNumberChange = (e) => {
        const value = e.target.value;

        if (!/^\d{8,17}$/.test(value)) {
            setAccountNumberError('Enter Valid Account Number');
        } else {
            setAccountNumberError('');
        }
       
        setAccountNumber(value);
    };

    const getLatLngFromAddress = async (address) => {
        const apiKey = process.env.REACT_APP_GOOGLE_MAP_KEY;
        const encodedAddress = encodeURIComponent(address);
        const response = await fetch(`https://maps.googleapis.com/maps/api/geocode/json?address=${encodedAddress}&key=${apiKey}`);
        const data = await response.json();
        if (data.status === 'OK') {
            const location = data.results[0].geometry.location;
            return `${location.lat},${location.lng}`;
        } else {
            throw new Error('Unable to geocode address');
        }
    };

    const handleSaveChanges = async () => {
        let isValid = true;

        if (!featureImagePreview) {
            setFeatureImageError('Please upload a feature image');
            isValid = false;
        } else {
            setFeatureImageError('');
        }

        if (!businessName) {
            setBusinessNameError('business name cannot be blank');
            isValid = false;
        } else if (businessName.length > 50) {
            setBusinessNameError('business name cannot be longer than 50 characters');
            isValid = false;
        }

        if (!legalBusinessName) {
            setLegalBusinessNameError('legal business name required');
            isValid = false;
        } else if (legalBusinessName.length > 25) {
            setLegalBusinessNameError('legal business name cannot be longer than 25 characters');
            isValid = false;
        }

        if (!address) {
            setAddressError('address cannot be blank');
            isValid = false;
        } else if (address.length > 100) {
            setAddressError('address cannot be longer than 100 characters');
            isValid = false;
        }

        if (!city) {
            setCityError('city cannot be blank');
            isValid = false;
        } else if (city.length > 25) {
            setCityError('city cannot be longer than 25 characters');
            isValid = false;
        }

        if (!state) {
            setStateError('state cannot be blank');
            isValid = false;
        } else if (state.length > 25) {
            setStateError('state cannot be longer than 25 characters');
            isValid = false;
        }

        if (!country) {
            setCountryError('country cannot be blank');
            isValid = false;
        } else if (country.length > 25) {
            setCountryError('country cannot be longer than 25 characters');
            isValid = false;
        }

        if (!zipcode) {
            setZipcodeError('zipcode cannot be blank');
            isValid = false;
        } else if (zipcode.length > 6) {
            setZipcodeError('zipcode cannot be longer than 6 characters');
            isValid = false;
        }

        if (!phoneNumber) {
            setPhoneNumberError('phone number cannot be blank');
            isValid = false;
        } else if (phoneNumber.length > 10) {
            setPhoneNumberError('phone number cannot be longer than 10 characters');
            isValid = false;
        }

        if (!representativeName) {
            setRepresentativeNameError('representative name cannot be blank');
            isValid = false;
        } else if (representativeName.length > 50) {
            setRepresentativeNameError('representative name cannot be longer than 50 characters');
            isValid = false;
        }

        if (!DOB) {
            setDOBError('Please enter date of birth');
            isValid = false;
        }

        if (!email) {
            setEmailError('email cannot be blank');
            isValid = false;
        } else if (email.length > 30) {
            setEmailError('email cannot be longer than 30 characters');
            isValid = false;
        }

        if (!taxID) {
            setTaxIDError('tax id cannot be blank');
            isValid = false;
        } else if (taxID.length > 30) {
            setTaxIDError('tax id cannot be longer than 30 characters');
            isValid = false;
        }

        if (!routingNumber) {
            setRoutingNumberError('routing number cannot be blank');
            isValid = false;
        } else if (routingNumber.length > 30) {
            setRoutingNumberError('routing number cannot be longer than 30 characters');
            isValid = false;
        }


        if (!accountNumber) {
            setAccountNumberError('account number cannot be blank');
            isValid = false;
        } else if (accountNumber.length > 50) {
            setAccountNumberError('account number cannot be longer than 50 characters');
            isValid = false;
        }

        if (isValid) {
            
            if (isSubmit) return; // Prevent save if already loading
            setIsSubmit(true); // Set loading to true when the request starts

            const fullAddress = `${address}, ${city}, ${state}, ${country}, ${zipcode}`;
            const location = await getLatLngFromAddress(fullAddress);
            const formData = new FormData();

            // Append text fields
            formData.append('Name', businessName);
            formData.append('Address', address);
            formData.append('city', city);
            formData.append('state', state);
            formData.append('country', country);
            formData.append('pincode', zipcode);
            formData.append('Phone_number', phoneNumber);
            formData.append('Date_of_birth', DOB);
            formData.append('Location', location);

            // Append images (Ensure restaurantImage & bannerImage are `File` objects)
            if (restaurantImage) {
                formData.append('Avatar_key', restaurantImage);
            }
            if (bannerImage) {
                formData.append('Banner_Image', bannerImage);
            }
            if (featureImage) {
                formData.append('featureImage', featureImage);
            }
            
            // Send updated data to the server
            axiosVendorInstance
                .put('/vendors/account',formData)
                .then(() => {
                    toast.success('Your profile updated successfully');
                    const updatedData = {
                        businessName,
                        legalBusinessName,
                        address,
                        city,
                        state,
                        country,
                        zipcode,
                        phoneNumber,
                        representativeName,
                        DOB,
                        email,
                        taxID,
                        routingNumber,
                        accountNumber,
                        restaurantImagePreview: restaurantImage ? URL.createObjectURL(restaurantImage) : restaurantImagePreview,
                        bannerImagePreview: bannerImage ? URL.createObjectURL(bannerImage) : bannerImagePreview,
                        featureImagePreview: featureImage ? URL.createObjectURL(featureImage) : featureImagePreview,
                    };
                    setInitialValues(updatedData);
                    setDisableButton(true);
                })
                .catch((error) =>  {
                    console.error('Error saving changes:', error);
                }).finally(()=>{

                    setIsSubmit(false); // Reset loading to false when the request ends

                });
        }
    };

    const imageURL = restaurantImagePreview?.trim() ? restaurantImagePreview : null;
    const fallbackLetter = (businessName || '').toUpperCase();

    const goBack = () => {
        window.history.back();
    };


    return (
        <div>
            {isSubmit && <Loader />}
            <div className="vendor-header-footer">
                <VendorTopMenuBar />
                <VendorSideMenuBar />
            </div>
            <div className="editprofile-top-mainn">
               
                <div className="edit-profile-main-c">
                    <div className="edit-profile-top1">
                        <div className='back-button11' onClick={() =>goBack()}>
                            <div className="ico1">
                                <MobileBackIcon />
                            </div>
                        </div>
                        <div className="edit-profile-text-layout">
                            <h5 className="edit-profile-text">
                               Edit Vendor
                            </h5>
                        </div>
                        <img src={bell} alt="bell" className="msg-icon" />
                    </div>
                    <div className="edit-profile-bottom">

                        <div className='banner-img-background'>

                         
                            {isLoading ? (
                                <Skeleton variant="rectangular" height={150} width="100%" />
                            ) : (
                                <img src={bannerImagePreview || DefaultBannerImge }  className='banner-image' alt="Profile" />
                            )}

                            <div className="banner-gallary-container">
                                <input
                                    type="file"
                                    id="fileInput"
                                    accept="image/*"
                                    style={{ display: 'none' }}
                                    onChange={handleBannerClick}
                                />
                                <label htmlFor="fileInput" className='banner-upload-img11'>
                                    <img src={gal} alt="gallery-icon" className="banner-gallary-img" />
                                </label>
                            </div>

                        </div>
                        <div className="restaurant-profile-gallary-container">
                           
                            {isLoading ? (
                                <Skeleton variant="square" height={130} width="130px" border />
                            ) : (

                                imageURL ? (
                                    <img src={restaurantImagePreview} className="restaurant-edit-profile-photo" alt="Profile" style={{ width: '100%', height: '100%', objectFit:'cover' }} />
                                ):(
                                    <span className='fall-back-letter-vendor'>{fallbackLetter}</span>
                                )
                            )}
                          
                            <div className="restaurant-gallary-container">
                                <input
                                    type="file"
                                    id="fileInputimg"
                                    accept="image/*"
                                    style={{ display: 'none' }}
                                    onChange={handleRestaurantImageClick}
                                />
                                <label htmlFor="fileInputimg" className='upload-image12'>
                                    <img src={gal} alt="gallery-icon" className="restaurant-gallary-img" />
                                </label>
                            </div>
                        </div>
                        <form className="restaurant-data-container">
                            <div className="feature-image-container">
                                <p className="profile-head-text">
                                       Feature Image
                                </p>
                                <div className="feature-image-wrapper" style={{border: featureImageError ? '1px solid red' : ''}}>
                                    {isLoading ? (
                                        <Skeleton variant="rectangular" width={300} height={200} />
                                    ) : featureImagePreview ? (
                                        <img
                                            src={featureImagePreview}
                                            alt="Feature"
                                            className="feature-image-preview"
                                        />
                                    ) : (
                                        <div className="feature-image-placeholder">Select Feature Image</div>
                                    )}
                                    <div className="restaurant-gallary-container">
                                        <input
                                            type="file"
                                            id="featureImageInput"
                                            accept="image/*"
                                            style={{ display: 'none' }}
                                            onChange={handleFeatureImageChange}
                                        />
                                        <label htmlFor="featureImageInput" className='upload-image12'>
                                            <img src={gal} alt="gallery-icon" className="restaurant-gallary-img" />
                                        </label>
                                    </div>
                                </div>
                                {featureImageError && (
                                    <p className='feature-image-error'>{featureImageError}</p>
                                )}
                            </div>
                            <div>
                                <p>
                                    <b>Note :</b> Please upload an image with a 6:4 aspect ratio, such as 1200px by 800px.
                                </p>
                            </div>
                            <div className="name-container">
                                <div className="firstname-container">
                                    <p className="profile-head-text">
                                       Business Name
                                    </p>
                                    <TextField
                                        className="txtfld-1"
                                        placeholder='Enter your business name'
                                        value={businessName}
                                        onChange={handleBusinessNameChange}
                                        error={!!businessNameError}
                                        helperText={businessNameError}
                                    />
                                </div>
                                <div className="lastname-container">
                                    <p className="profile-head-text">
                                       Legal Business Name
                                    </p>
                                    <TextField
                                        placeholder='Enter your legal business name'
                                        value={legalBusinessName}
                                        onChange={handleLegalBusinessNameChange}
                                        error={!!legalBusinessNameError}
                                        helperText={legalBusinessNameError}
                                        InputProps={{ 
                                            readOnly: true ,
                                            sx: { backgroundColor: '#f5f5f5', color: '#757575' },
                                        }}
                                    />
                                </div>
                            </div>

                            <div className="name-container">
                                <div className="firstname-container">
                                    <p className="profile-head-text">
                                      Address
                                    </p>
                                    <TextField
                                        className="txtfld-1"
                                        placeholder='Enter your address'
                                        value={address}
                                        onChange={handleAddressChange}
                                        error={!!addressError}
                                        helperText={addressError}
                                    />
                                </div>
                                <div className="lastname-container">
                                    <p className="profile-head-text">
                                       city
                                    </p>
                                    <TextField
                                        placeholder='Enter your city'
                                        value={city}
                                        onChange={handleCityChange}
                                        error={!!cityError}
                                        helperText={cityError}
                                    />
                                </div>
                            </div>

                            <div className="name-container">
                                <div className="firstname-container">
                                    <p className="profile-head-text">
                                      state
                                    </p>
                                    <TextField
                                        className="txtfld-1"
                                        placeholder='Enter your state'
                                        value={state}
                                        onChange={handleStateChange}
                                        error={!!stateError}
                                        helperText={stateError}
                                    />
                                </div>
                                <div className="lastname-container">
                                    <p className="profile-head-text">
                                       country
                                    </p>
                                    <TextField
                                        placeholder='Enter your country'
                                        value={country}
                                        onChange={handleCountryChange}
                                        error={!!countryError}
                                        helperText={countryError}
                                    />
                                </div>
                            </div>

                            <div className="name-container">
                                <div className="firstname-container">
                                    <p className="profile-head-text">
                                      zipcode
                                    </p>
                                    <TextField
                                        className="txtfld-1"
                                        placeholder='Enter your zipcode'
                                        value={zipcode}
                                        onChange={handleZipcodeChange}
                                        error={!!zipcodeError}
                                        helperText={zipcodeError}
                                    />
                                </div>
                                <div className="lastname-container">
                                    <p className="profile-head-text">
                                       phone number
                                    </p>
                                    <TextField
                                        placeholder='Enter your phone number'
                                        value={phoneNumber}
                                        onChange={handlePhoneNumberChange}
                                        error={!!phoneNumberError}
                                        helperText={phoneNumberError}
                                    />
                                </div>
                            </div>

                            <div className="name-container">
                                <div className="firstname-container">
                                    <p className="profile-head-text">
                                      Representative Name
                                    </p>
                                    <TextField
                                        className="txtfld-1"
                                        placeholder='Enter your representative name'
                                        value={representativeName}
                                        onChange={handleRepresentativeNameChange}
                                        error={!!representativeNameError}
                                        helperText={representativeNameError}
                                    />
                                </div>
                                <div className="lastname-container">
                                    <p className="profile-head-text">
                                       Date of Birth
                                    </p>
                                                             
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DatePicker
                                            value={DOB ? dayjs(DOB, 'YYYY-MM-DD') : null}
                                            onChange={handleDOBChange}
                                            slotProps={{
                                                textField: {
                                                    error: !!DOBError,
                                                    helperText: DOBError,
                                                    fullWidth: true
                                                }
                                            }}
                                            maxDate={dayjs()}
                                            format="YYYY-MM-DD"
                                        />
                                    </LocalizationProvider>
                                                                
                                </div>
                            </div>
                            <div className="username-container">
                                <p className="profile-head-text">
                                   Email
                                </p>
                                <TextField
                                    placeholder='Enter your email'
                                    value={email}
                                    onChange={handleEmailChange}
                                    error={!!emailError}
                                    helperText={emailError}
                                    InputProps={{ 
                                        readOnly: true ,
                                        sx: { backgroundColor: '#f5f5f5', color: '#757575' }, // Light gray background & gray text
                                    }}
                                />
                            </div>
                            <div className="dob-container">
                                <p className="profile-head-text">
                                    EIN/Tax ID
                                </p>
                                <TextField
                                    placeholder='Enter your EIN/Tax ID'
                                    value={taxID}
                                    onChange={handleTaxIDChange}
                                    error={!!taxIDError}
                                    helperText={taxIDError}
                                    InputProps={{ 
                                        readOnly: true ,
                                        sx: { backgroundColor: '#f5f5f5', color: '#757575' }, // Light gray background & gray text
                                    }} 
                                />
                            </div>

                            <div className="username-container">
                                <p className="profile-head-text">
                                   Routing Number
                                </p>
                                <TextField
                                    placeholder='Enter your routing number'
                                    value={routingNumber}
                                    onChange={handleRoutingNumberChange}
                                    error={!!routingNumberError}
                                    helperText={routingNumberError}
                                    InputProps={{ 
                                        readOnly: true ,
                                        sx: { backgroundColor: '#f5f5f5', color: '#757575' }, // Light gray background & gray text
                                    }}
                                />
                            </div>
                            <div className="username-container">
                                <p className="profile-head-text">
                                   Account Number
                                </p>
                                <TextField
                                    placeholder='Enter your account number'
                                    value={accountNumber}
                                    onChange={handleAccountNumberChange}
                                    error={!!accountNumberError}
                                    helperText={accountNumberError}
                                    InputProps={{ 
                                        readOnly: true ,
                                        sx: { backgroundColor: '#f5f5f5', color: '#757575' }, 
                                    }} 
                                />
                            </div>

                            <div>
                                <p>
                                    <b>Note :</b> To change more information please contact  <a href=''>support@omyfood.io</a>
                                </p>
                            </div>
                            <div className="restaurant-save-changes-layout">
                                <Button
                                    variant="contained"
                                    style={{
                                        backgroundColor: disableButton ? 'gray' : 'var(--color4)',
                                        cursor: disableButton ? 'not-allowed' : 'pointer',
                                        opacity: disableButton ? 0.7 : 1,
                                        color: '#FFFFFF'
                                    }}
                                    onClick={handleSaveChanges}
                                    className="save-changes-button"
                                    disabled={disableButton}
                                >
                                    {isSubmit ? 'updating...' : 'Save Changes'}
                                </Button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
}
